export default __webpack_public_path__ + "static/media/test2-slots.1d245d28.png";